
import Footer from '../Footer/Footer'
import Header from '../Header'
import Mission from "../Mission/Mission"
import Aims from '../Aims/Aims'
import Director from '../Director/Director'
import Vice from '../Vice/Vice'

const About = () => {
  return (
    <div>
        <Header />
        <Mission />
        <br />
        <br />
        <Aims />
        <br />
        <br />
        <Vice />
        <br />
        <br />
        <Director />
        <br />
        <br />
        <Footer />
    </div>
  )
}

export default About